import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ModalService } from '@luggagehero/core';
import { ModifyBookingActionBaseComponent } from '@luggagehero/features/bookings';
import { SharedBookingService } from '@luggagehero/shared/services/bookings';
import { SharedErrorService } from '@luggagehero/shared/services/error';
import { SharedNotificationService } from '@luggagehero/shared/services/notification';
import { SharedOrderService } from '@luggagehero/shared/services/orders';
import { SharedPricingService } from '@luggagehero/shared/services/pricing';
import { SharedPromoCodeService } from '@luggagehero/shared/services/promo-codes';
import { SharedShopsService } from '@luggagehero/shared/services/shops';
import { SharedStorageService } from '@luggagehero/shared/services/storage';
import { SharedStorageCriteriaService } from '@luggagehero/shared/services/storage-criteria';
import { PromoCodeComponent } from '@luggagehero/web/features/ui';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lh-modify-booking-booking-action',
  templateUrl: './modify-booking-action.component.html',
  styleUrls: ['./modify-booking-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModifyBookingActionComponent extends ModifyBookingActionBaseComponent implements AfterViewInit {
  public constructor(
    private modalService: ModalService,
    translate: TranslateService,
    error: SharedErrorService,
    notify: SharedNotificationService,
    criteriaService: SharedStorageCriteriaService,
    priceService: SharedPricingService,
    promoCodeService: SharedPromoCodeService,
    orderService: SharedOrderService,
    bookingService: SharedBookingService,
    shopsService: SharedShopsService,
    storageService: SharedStorageService,
    cd: ChangeDetectorRef,
  ) {
    super(
      translate,
      error,
      notify,
      criteriaService,
      priceService,
      promoCodeService,
      orderService,
      bookingService,
      shopsService,
      storageService,
      cd,
    );
  }

  showPromoCodeModal() {
    void this.modalService.show({ component: PromoCodeComponent });
  }
}
